import { TypographyText } from '@/components/base/Typography';
import { cn } from '@/utils';

const LOADING_TEXT = 'Loading...';
const ERROR_TEXT = 'An error on our end!';
const NOT_FOUND_TEXT = 'The content you are looking for does not exist.';

interface StateProps {
  text?: string;
  className?: string;
  textClassName?: string;
}

export const Loading = ({ text = LOADING_TEXT, className, textClassName }: StateProps) => {
  return (
    <div className={cn('flex h-[calc(100vh-76px)] items-center justify-center', className)}>
      <TypographyText className={cn('text-slate-300', textClassName)}>{text}</TypographyText>
    </div>
  );
};

export const Error = ({ text = ERROR_TEXT, className, textClassName }: StateProps) => {
  return (
    <div className={cn('flex h-[calc(100vh-76px)] items-center justify-center', className)}>
      <TypographyText className={cn('text-slate-300', textClassName)}>{text}</TypographyText>
    </div>
  );
};

export const NotFound = ({ text = NOT_FOUND_TEXT, className, textClassName }: StateProps) => {
  return (
    <div className={cn('flex h-[calc(100vh-76px)] items-center justify-center', className)}>
      <TypographyText className={cn('text-slate-300', textClassName)}>{text}</TypographyText>
    </div>
  );
};

export const ButtonSpinner = ({ className }: React.ComponentProps<'svg'>) => {
  return (
    <svg
      className={cn('h-5 w-5 animate-spin text-white', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" fill="currentColor" />
    </svg>
  );
};

export const LoadingSpinner = ({ className }: React.ComponentProps<'svg'>) => {
  return (
    <svg
      className={cn('h-6 w-6 animate-spin text-slate-500', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        fill="currentColor"
      />
    </svg>
  );
};
